import { useTranslation } from 'react-i18next'

import { TabCard } from '@/components/layout/tab-card'

import { PlaceFeatureGroupSection } from '../../flags/place-feature-group'
import { PlaceFeatureGroupedListSkeleton } from '../../flags/place-feature-grouped-list'
import { PlaceFeaturesView } from '../../place-details.types'
import { AccessControlClassicLayout } from './access-control-classic-layout'
import { ACCESS_CONTROL_GROUPS } from './access-control-tab'

interface AccessControlTabSkeletonProps {
  isAdmin: boolean
  view?: PlaceFeaturesView
}

// Note: title, group headers and labels are real, only the values are skeletons
export const AccessControlTabSkeleton = ({
  isAdmin,
  view = PlaceFeaturesView.classic,
}: AccessControlTabSkeletonProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.accessControl.tab.title')}>
      {view === PlaceFeaturesView.grouped ? (
        <PlaceFeatureGroupedListSkeleton groups={ACCESS_CONTROL_GROUPS} />
      ) : (
        <AccessControlClassicLayout
          renderGroup={(group, splitPart, extraCards) => (
            <PlaceFeatureGroupSection
              splitByBranch
              extraCards={extraCards}
              group={group}
              isAdmin={isAdmin}
              isEditing={false}
              splitPart={splitPart}
            />
          )}
        />
      )}
    </TabCard>
  )
}
